import init from '../../helpers/init';
import 'select2';

const { $, _ } = init;
const BX = (<any>window).BX;

$(() => {
  let productGroup = $("#sectionsProductGroup");
  let addBlockHtml = $(productGroup).find('li.newItem').clone();
  let lastId = 0;
  $(productGroup).find('li.newItem').remove();
  $(productGroup).find('li.dd-item').each(function () {
    let res = $(this).attr('data-id').match(/_n(\d+)/g);
    if (res) {
      let id = parseInt($(this).attr('data-id').replace(/_n/g, ''), 10);
      if (id >= lastId) lastId = id + 1;
    }
  });

  $(productGroup).find('select.answersList').select2({
    allowClear: true
  });

  let addProductGroup = function () {
    let inner = $(productGroup).find('ol.dd-list').get(0);
    $(addBlockHtml).html($(addBlockHtml).html().replace(/\[_n\d+\]/g, '[_n' + lastId + ']')).attr('data-id', '_n' + lastId);
    if ($(this).closest('li.dd-item').get(0)) {
      if (!$(this).closest('li.dd-item').find('ol.dd-list').get(0)) $(this).closest('li.dd-item').addClass('is_parent').append('<ol class="dd-list">');
      if (!$(this).closest('li.dd-item').find('button[data-action=collapse]').get(0)) $(this).closest('li.dd-item').addClass('is_parent').prepend('<button data-action="collapse" type="button">Collapse</button>');
      if (!$(this).closest('li.dd-item').find('button[data-action=expand]').get(0)) $(this).closest('li.dd-item').addClass('is_parent').prepend('<button data-action="expand" style="display:none;" type="button">Expand</button>');
      inner = $(this).closest('li.dd-item').find('ol.dd-list').get(0);
      $(addBlockHtml).find('.parent_section_id').val($(this).data('parent-id'));
    }
    $(inner).prepend(addBlockHtml.clone());
    lastId++;
    $(productGroup).find('select.answersList').select2({
      allowClear: true
    });
    $(productGroup).trigger('change');
    return false;
  }

  let deleteProductGroup = function () {
    if ($(this).closest('li.dd-item').closest('ol.dd-list').get(0) && $(this).closest('li.dd-item').closest('ol.dd-list').children('li').length == 1 && $(this).closest('li.dd-item').closest('ol.dd-list').closest('li.dd-item').get(0)) {
      $(this).closest('li.dd-item').closest('ol.dd-list').closest('li.dd-item').children('button[data-action=collapse]').remove();
      $(this).closest('li.dd-item').closest('ol.dd-list').closest('li.dd-item').children('button[data-action=expand]').remove();
      $(this).closest('li.dd-item').closest('ol.dd-list').remove();
    } else {
      $(this).closest('li.dd-item').remove();
    }
    return false;
  };

  let setShowProductGroupCollapsed = function () {
    let currentGroup = $(this);
    let currentValue = $(currentGroup).find('input[name^=SHOW_COLLAPSED]').val();
    if (currentValue === "Y") {
      $(currentGroup).find('input[name^=SHOW_COLLAPSED]').val("N");
      $(currentGroup).find('input[name^=SHOW_COLLAPSED]').closest('a').removeClass('btn-primary');
    } else {
      $(currentGroup).find('input[name^=SHOW_COLLAPSED]').val("Y");
      $(currentGroup).find('input[name^=SHOW_COLLAPSED]').closest('a').addClass('btn-primary');
    }
    return false;
  }

  $(productGroup).on('click', '.blockBtns button.add, .btns button.add', addProductGroup);
  $(productGroup).on('click', '.btns button.remove', deleteProductGroup);
  $(productGroup).on('click', '.btns .btn_show_collapsed', setShowProductGroupCollapsed);
  $('#blockBtnsSectionsProductGroup').find('button.add').on('click', addProductGroup);

  /**
   * расставлем классы для групп с выбранными ответами
   */
  if ($('.js-product-group-answers-select').length && $('.js-answers-group-json').length) {
    let answerData = $.parseJSON(String($('.js-answers-group-json').val()));
    $('.js-product-group-answers-select').each(function () {
      let d = $(this).attr('data');
      if (d) {
        if (answerData[d] && answerData[d].length) {
          $(this).addClass('btn-selected-groups');
        }
      }
    });
  }

  /**
   * сохраняем сопоставление
   */
  $(document).on('submit', 'form.js-select-questions-for-group-form', function (event) {
    event.preventDefault();
    let form = $(this);
    BX.ajax.runComponentAction('pwd:exhibition.questions.selector', 'saveAnswers', {
      mode: 'ajax',
      data: {
        group: form.find('input.js-product-group-for-questions').val(),
        answers: form.find('select.js-answer-for-group-selector').val(),
        questionnaireId: form.find('input.js-questionnaire-id-for-questions').val(),
      }
    }).then(function (response: any) {
      if (response.data.success != 1) {
        alert('Error');
      } else {
        location.reload();
      }
    }).catch((err: any) => {
      alert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });
  });

  /**
   * popup выбора ответа
   */
  $(document).on('click', '.js-product-group-answers-select', function (event) {
    event.preventDefault();
    let d = $(this).attr('data');
    if (d && $('#popupOfficeExhibitionQuestionSelector').length && $('.js-answers-group-json').length) {
      let answerData = $.parseJSON(String($('.js-answers-group-json').val()));
      if (answerData[d]) {
        $.each(answerData[d], function (i, v) {
          $('#popupOfficeExhibitionQuestionSelector form select.js-answer-for-group-selector option[value="' + v + '"]').prop('selected', true);
        });
        $('#popupOfficeExhibitionQuestionSelector form select.js-answer-for-group-selector').trigger("change");
      }

      $('#popupOfficeExhibitionQuestionSelector form .js-product-group-for-questions').val(d);

      $('#popupOfficeExhibitionQuestionSelector').modal('show');
    } else {
      alert(BX.message('LANGUAGE_ID') === 'en' ? 'No questions in the exhibition!' : 'Не выбраны вопросы в выставке');
    }
  });

  // закрытие модалки
  $('#popupOfficeExhibitionQuestionSelector').on('hidden.bs.modal', function () {
    if ($('#popupOfficeExhibitionQuestionSelector form').length) {
      $('#popupOfficeExhibitionQuestionSelector form .js-product-group-for-questions').val('');
      $('#popupOfficeExhibitionQuestionSelector form select.js-answer-for-group-selector').val(null).trigger("change");
      $('#popupOfficeExhibitionQuestionSelector form').trigger('reset');
    }
  });
});
